<template>
    <v-container fluid>
        <reseller-form
            :model="reseller"
            :newReseller="true"
            @saved="saved"
            type="create"
            :titlePrefix="$t('partner.create.texts.title-prefix')"
        ></reseller-form>
    </v-container>
</template>

<script>
import ResellerModel from '@/models/Reseller'
import ResellerForm from './Form'

export default {
    components: {
        'reseller-form': ResellerForm,
    },

    data: () => {
        return {
            reseller: new ResellerModel(),
        }
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>
